import FetchService from "./Shared/FetchService";
export default class MeetingRequestService {
    static acceptMeetingRequest(meetingRequestId) {
        return FetchService.postSingleResponse("/aviso/advisor/acceptMeetingRequest/", { meetingRequestId });
    }
    static cancelMeetingRequest(meetingRequestId) {
        return FetchService.postSingleResponse("/aviso/advisor/cancelMeetingRequest/", { meetingRequestId });
    }
    static assignMeetingRequestToFirstAvailableStaff(meetingRequestId) {
        return FetchService.postSingleResponse("/aviso/advisor/assignMeetingRequestToFirstAvailableStaff/", { meetingRequestId });
    }
    static saveMeetingRequestAvailabilityStatus(meetingRequestAvailabilityStatus, activeServiceDeliveryLocationId) {
        return FetchService.postSingleResponse("/aviso/advisor/saveMeetingRequestAvailabilityStatus", {
            settings: {
                meetingRequestAvailabilityStatus,
                activeServiceDeliveryLocationId,
            },
        });
    }
    static assignQueuedMeetingRequestsByStaffToFirstAvailableStaff() {
        return FetchService.postSingleResponse("/aviso/advisor/assignQueuedMeetingRequestsByStaffToFirstAvailableStaff", {});
    }
}
